module.exports = __webpack_public_path__ + "assets/img/ktz_img2.bcb49cb5.png";